import { Component } from "@builder.io/sdk";

export const ciAppDemoFormConfig: Component = {
  name: "CI App Demo Form",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Transform Your Care Facility Today",
    },
    {
      name: "className",
      type: "string",
    },
    {
      name: "redirectUrl",
      type: "string",
      helperText:
        "URL to redirect to after successful form submission (e.g., thank you page or scheduling page)",
      defaultValue: "/thank-you",
    },
  ],
};
